export enum CompanyReqQueryParam {
  CompanyTicker = 'companyTicker',
}
